exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-body{\n    height:100px;\n    text-align: center;\n    margin-top: 15px;\n}\n\n.custom-top-margin{\n    margin-top: 7px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/activities/activities-list/activities-list.component.css
// module id = ../../../../../src/app/activities/activities-list/activities-list.component.css
// module chunks = main